import { globalThis_ } from "./globalThis.mjs";
//#region src/_internal/DOMException.ts
const DOMException = typeof globalThis_.DOMException !== "undefined" ? globalThis_.DOMException : Error;
//#endregion
export { DOMException };
